import { Globe, User } from 'lucide-react'
import { Helmet } from 'react-helmet'
import { useLocation, useNavigate } from 'react-router'

import { ToggleTabs } from '@/components/ui/ToggleTabs'
import { useSequenceTemplates } from '@/models/sequenceTemplate'
import { SequenceTemplatesPane } from './SequenceTemplatesPane'

enum TemplatesTab {
  GLOBAL = 'global',
  PERSONAL = 'personal',
}

function tabFromHash(hash: string): TemplatesTab {
  const value = hash.slice(1)
  return Object.values<string>(TemplatesTab).includes(value) ? (value as TemplatesTab) : TemplatesTab.GLOBAL
}

export function SequenceTemplatesIndex() {
  const location = useLocation()
  const navigate = useNavigate()
  const tab = tabFromHash(location.hash)
  const { data: templates = [], isLoading } = useSequenceTemplates()

  function onTabChange(value: string) {
    void navigate(
      { search: location.search, hash: value === TemplatesTab.GLOBAL ? '' : value },
      { replace: true, preventScrollReset: true }
    )
  }

  return (
    <>
      <Helmet>
        <title>Sequence Templates</title>
      </Helmet>
      <div className="flex flex-col gap-6 p-6">
        <h1 className="text-2xl font-semibold">Sequence Templates</h1>
        <ToggleTabs
          value={tab}
          onValueChange={onTabChange}
          className="w-full gap-4"
          items={[
            { value: TemplatesTab.GLOBAL, icon: <Globe />, label: 'Global' },
            { value: TemplatesTab.PERSONAL, icon: <User />, label: 'Personal' },
          ]}
        >
          {tab === TemplatesTab.GLOBAL && (
            <SequenceTemplatesPane
              templates={templates.filter((t) => t.isGlobal)}
              isLoading={isLoading}
              isGlobal
              emptyText="No global templates yet."
            />
          )}
          {tab === TemplatesTab.PERSONAL && (
            <SequenceTemplatesPane
              templates={templates.filter((t) => !t.isGlobal)}
              isLoading={isLoading}
              isGlobal={false}
              emptyText="No personal templates yet."
            />
          )}
        </ToggleTabs>
      </div>
    </>
  )
}
